//import Libraries
import React, { Component } from 'react';
import {connect} from 'react-redux';

//import Components
import {Container} from 'reactstrap'

import AdminOrderableFormManager from '../Components/AdminOrderableFormManager/AdminOrderableFormManager';
import AdminDepartmentFormManager from '../Components/AdminDepartmentFormManager/AdminDepartmentFormManager';

import HistoryManager from './HistoryManager/HistoryManager';
import ArticleManager from './ArticleManager/ArticleManager';

import * as adminActions from '../actions/adminActions';
import * as imageActions from '../actions/imageActions';
import * as htmlActions from '../actions/htmlActions';
import * as homepageActions from './actions/homepageActions';


//import Styles
import '../Admin.css'

const homepageManager = (props) => {
    return (
        <div className="admin-element">
            <Container>
                <h1>
                    홈페이지 관리
                    </h1>
                <hr />
                <HistoryManager />
                <ArticleManager />
                <AdminOrderableFormManager 
                    startCollapse={false}
                    title="메인일러스트 관리"
                    dbPath="mains"
                    datas={props.mains}
                    storagePath={'main_images'}
                />
                <AdminOrderableFormManager 
                    startCollapse={false}
                    title="소개 관리"
                    dbPath="introductions"
                    datas={props.introductions}
                    storagePath={'introduction_images'}
                />
                <AdminOrderableFormManager 
                    startCollapse={false}
                    title="사례 관리"
                    dbPath="cases"
                    datas={props.cases}
                    storagePath={'case_images'}
                />
                <AdminDepartmentFormManager 
                    startCollapse={false}
                    title="시공 관리"
                    datas={props.constructions}
                    dbPath={'constructions'}
                    storagePath={'construction_images'}
                />
                {/* <AdminDepartmentFormManager 
                    startCollapse={false}
                    title="자재 관리"
                    datas={props.materials}
                    dbPath={'materials'}
                    storagePath={'material_images'}
                /> */}
                <AdminDepartmentFormManager 
                    startCollapse={false}
                    title="비료 관리"
                    datas={props.fertilizers}
                    dbPath={'fertilizers'}
                    storagePath={'fertilizer_images'}
                />
                <AdminDepartmentFormManager 
                    startCollapse={false}
                    title="배지 관리"
                    datas={props.mediums}
                    dbPath={'mediums'}
                    storagePath={'medium_images'}
                />
                <AdminDepartmentFormManager 
                    startCollapse={false}
                    title="기타 관리"
                    datas={props.extras}
                    dbPath={'extras'}
                    storagePath={'extra_images'}
                />
            </Container>
        </div>
        );
}

const mapStateToProps = (state) => {
    return {
        mains : state.admin.homepage.mains,
        introductions : state.admin.homepage.introductions,
        cases : state.admin.homepage.cases,
        constructions : state.admin.homepage.constructions,
        // materials : state.admin.homepage.materials,
        fertilizers : state.admin.homepage.fertilizers,
        mediums : state.admin.homepage.mediums,
        extras : state.admin.homepage.extras,
    }
} 

export default connect(mapStateToProps, null)(homepageManager);


// WEBPACK FOOTER //
// ./src/pages/Admin/HomepageManager/HomepageManager.js